module.exports = __webpack_public_path__ + "fc9c1dcdcb32684bf0bcf8d9cab65281.jpg";


//////////////////
// WEBPACK FOOTER
// ./2017-04-04-harrison-first-day-in-india/elephant-drawing.jpg
// module id = 566
// module chunks = 0